<div id="content" class="extensible">
  <div class="page-title">
    <h1>{{ page_title }}</h1>
    <button mat-flat-button color="accent" (click)="openAddPotentialClientDialog()">Añadir cliente potencial</button>
    <button mat-icon-button [matMenuTriggerFor]="pageActionsMenu" aria-label="Más acciones">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #pageActionsMenu="matMenu">
      @if (employee.meetingModeEnabled | async) {
        <button mat-menu-item (click)="disableMeetingMode()">
          <mat-icon>groups</mat-icon>
          <span>Desactivar modo reunión</span>
        </button>
      } @else {
        <button mat-menu-item (click)="enableMeetingMode()">
          <mat-icon>groups</mat-icon>
          <span>Activar modo reunión</span>
        </button>
      }
      <button mat-menu-item (click)="openImportPotentialClientsDialog()">
        <mat-icon>upload_file</mat-icon>
        <span>Importar leads</span>
      </button>
      <button mat-menu-item (click)="openSyncMetaLeadsDialog()">
        <mat-icon>sync</mat-icon>
        <span>Sincronizar Meta</span>
      </button>
    </mat-menu>
  </div>

  <div class="card pc-status-counts-card">
    <div class="row g-2">
      <div class="col-6 col-sm-4 col-md-3 col-xl">
        <button type="button" class="metric-card-style" [class.active]="isAllStatusesSelected()" (click)="selectAllStatuses()">
          <h5 class="metric-card-title">Total</h5>
          <h2 class="metric-card-value">{{ statusCountsTotal }}</h2>
        </button>
      </div>
      @for (metric of statusCounts; track metric.slug) {
        <div class="col-6 col-sm-4 col-md-3 col-xl">
          <button
            type="button"
            class="metric-card-style"
            [class.active]="isStatusSelected(metric.slug)"
            (click)="toggleStatusFilter(metric.slug)"
          >
            <h5 class="metric-card-title">{{ metric.name }}</h5>
            <h2 class="metric-card-value">{{ metric.count }}</h2>
          </button>
        </div>
      }
    </div>
  </div>

  <div class="bisual-table">
    <form class="card paginator" [formGroup]="filterForm">
      <mat-form-field appearance="outline" class="period-field">
        <mat-label>Periodo</mat-label>
        <mat-date-range-input [rangePicker]="periodPicker">
          <input matStartDate formControlName="from" placeholder="Todos" />
          <input matEndDate formControlName="to" placeholder="Todos" />
        </mat-date-range-input>
        @if (hasPeriodFilter()) {
          <button matSuffix mat-icon-button type="button" aria-label="Quitar filtro de periodo" (click)="clearPeriodFilter()">
            <mat-icon>close</mat-icon>
          </button>
        }
        <mat-datepicker-toggle matSuffix [for]="periodPicker"></mat-datepicker-toggle>
        <mat-date-range-picker #periodPicker></mat-date-range-picker>
      </mat-form-field>

      <mat-form-field>
        <input matInput type="text" formControlName="search" />
        <button matSuffix mat-icon-button aria-label="Clear">
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field appearance="outline" class="bisual-paginator-select">
        <mat-label>Estado</mat-label>
        <mat-select formControlName="potential_client_status_slug" multiple panelWidth>
          @for (status of potentialClientStatuses; track status.slug) {
            <mat-option [value]="status.slug">{{ status.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="bisual-paginator-select">
        <mat-label>Origen</mat-label>
        <mat-select formControlName="origin_id" panelWidth>
          <mat-option [value]="''">Todos</mat-option>
          @for (origin of origins; track origin.id) {
            <mat-option [value]="origin.id">{{ origin.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="bisual-paginator-select">
        <mat-label>Comercial</mat-label>
        <mat-select formControlName="commercial_id" panelWidth>
          <mat-option [value]="''">Todos</mat-option>
          @for (commercial of commercials; track commercial.id) {
            <mat-option [value]="commercial.id">{{ commercial.name }} {{ commercial.surnames }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-paginator
        [length]="length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        [pageIndex]="pageIndex"
        (page)="changePage($event)"
        style="margin-right: auto"
      >
      </mat-paginator>
    </form>

    <div class="bisual-table-container">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Nombre / empresa</th>
          <td mat-cell *matCellDef="let item">
            <div>{{ item.full_name }}</div>
            @if (item.company_name) {
              <small>{{ item.company_name }}</small>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="phone">
          <th mat-header-cell *matHeaderCellDef>Teléfono</th>
          <td mat-cell *matCellDef="let item">
            <div class="pc-contact-cell">
              <span>{{ item.phone || '-' }}</span>
              @if (item.phone && canUseRingover) {
                <button
                  mat-icon-button
                  type="button"
                  class="pc-inline-action"
                  matTooltip="Llamar"
                  (click)="callLead(item); $event.stopPropagation()"
                >
                  <mat-icon>call</mat-icon>
                </button>
              }
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>Correo</th>
          <td mat-cell *matCellDef="let item">{{ item.email || '-' }}</td>
        </ng-container>

        <ng-container matColumnDef="origin">
          <th mat-header-cell *matHeaderCellDef>Origen</th>
          <td mat-cell *matCellDef="let item">{{ item.origin?.name ?? '-' }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Estado</th>
          <td mat-cell *matCellDef="let item">
            <button
              type="button"
              class="status-badge status-badge--clickable"
              [attr.data-status]="item.potential_client_status_slug"
              (click)="openChangeStatusDialog(item); $event.stopPropagation()"
              matTooltip="Cambiar estado"
            >
              {{ item.potential_client_status.name }}
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions_count">
          <th mat-header-cell *matHeaderCellDef>Acciones</th>
          <td mat-cell *matCellDef="let item">
            <div class="pc-action-icons">
              @for (actionType of actionTypes; track actionType.value) {
                <button
                  type="button"
                  class="pc-action-chip"
                  [ngClass]="'type-' + actionType.value"
                  [class.done]="actionCount(item, actionType.countKey) > 0"
                  [matTooltip]="actionType.label"
                  (click)="registerAction(item, actionType.value); $event.stopPropagation()"
                >
                  <span class="pc-action-count">{{ actionCount(item, actionType.countKey) }}</span>
                  @if (actionType.icon === 'whatsapp') {
                    <svg class="pc-action-svg" viewBox="0 0 24 24" aria-hidden="true">
                      <path
                        fill="currentColor"
                        d="M17.47 14.38c-.29-.15-1.72-.85-1.98-.95-.27-.1-.46-.15-.66.15-.2.29-.76.95-.93 1.14-.17.2-.34.22-.63.07-.29-.15-1.22-.45-2.33-1.44-.86-.77-1.44-1.72-1.61-2.01-.17-.29-.02-.45.13-.6.13-.13.29-.34.44-.51.15-.17.2-.29.29-.49.1-.2.05-.37-.02-.52-.07-.15-.66-1.59-.9-2.18-.24-.57-.48-.49-.66-.5h-.56c-.2 0-.52.07-.79.37-.27.29-1.04 1.02-1.04 2.48s1.07 2.88 1.22 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.09 1.72-.7 1.96-1.38.24-.68.24-1.26.17-1.38-.07-.12-.26-.2-.55-.34zM12.04 21.8h-.01a9.78 9.78 0 0 1-4.98-1.36l-.36-.21-3.7.97 1-3.61-.24-.37a9.76 9.76 0 0 1-1.5-5.21C2.25 6.34 6.6 2 11.99 2c2.61 0 5.06 1.02 6.91 2.87A9.7 9.7 0 0 1 21.75 12c0 5.4-4.39 9.8-9.71 9.8zm8.41-17.2A11.55 11.55 0 0 0 12 0C5.45 0 .12 5.33.12 11.88c0 2.09.55 4.14 1.59 5.94L0 24l6.34-1.66a11.86 11.86 0 0 0 5.66 1.44h.01c6.55 0 11.88-5.33 11.88-11.88 0-3.17-1.24-6.16-3.48-8.4z"
                      />
                    </svg>
                  } @else {
                    <mat-icon>{{ actionType.icon }}</mat-icon>
                  }
                </button>
              }
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="last_action">
          <th mat-header-cell *matHeaderCellDef>Últ. acción</th>
          <td mat-cell *matCellDef="let item">
            @if (lastAction(item); as action) {
              {{ actionLabel(action.type) }}
              <small>· {{ action.created_at | date: 'short' }}</small>
            } @else {
              -
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="comercial">
          <th mat-header-cell *matHeaderCellDef>Comercial</th>
          <td mat-cell *matCellDef="let item">{{ item.commercial.name + ' ' + item.commercial.surnames }}</td>
        </ng-container>

        <ng-container matColumnDef="meta_form_submitted_at">
          <th mat-header-cell *matHeaderCellDef>Form. Meta</th>
          <td mat-cell *matCellDef="let item">
            {{ item.meta_form_submitted_at ? (item.meta_form_submitted_at | date: 'short') : '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="updated_at">
          <th mat-header-cell *matHeaderCellDef>Últ. actualización</th>
          <td mat-cell *matCellDef="let item">{{ item.updated_at | date: 'short' }}</td>
        </ng-container>

        <ng-container matColumnDef="actions" stickyEnd>
          <th mat-header-cell *matHeaderCellDef aria-label="Acciones"></th>
          <td mat-cell *matCellDef="let item">
            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Más acciones">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item [routerLink]="getDetailRouterLink(item)" [queryParams]="getDetailQueryParams()">
                <mat-icon>visibility</mat-icon>
                <span>Ver detalle...</span>
              </button>
              <button mat-menu-item (click)="openChangeStatusDialog(item)">
                <mat-icon>refresh</mat-icon>
                <span>Cambiar estado...</span>
              </button>
              <button mat-menu-item [disabled]="!item.phone || !canUseRingover" (click)="callLead(item)">
                <mat-icon>call</mat-icon>
                <span>Llamar</span>
              </button>
              <button mat-menu-item [disabled]="!item.email" (click)="openEmail(item)">
                <mat-icon>mail</mat-icon>
                <span>Enviar email</span>
              </button>
              <button
                mat-menu-item
                [disabled]="item.potential_client_status_slug === rejectedStatusSlug"
                (click)="rejectAsDoesNotQualify(item)"
              >
                <mat-icon>thumb_down</mat-icon>
                <span>No califica</span>
              </button>
              <button mat-menu-item [matMenuTriggerFor]="actionsMenu">
                <mat-icon>bolt</mat-icon>
                <span>Acción rápida</span>
              </button>
            </mat-menu>
            <mat-menu #actionsMenu="matMenu">
              @for (actionType of actionTypes; track actionType.value) {
                <button mat-menu-item (click)="registerAction(item, actionType.value)">
                  <span>{{ actionType.label }}</span>
                </button>
              }
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</div>
